var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landing-close"},[_c('div',{staticClass:"landing-control-item"},[_c('div',{staticClass:"spacer-30"}),_c('base-button',{staticClass:"btn-close",on:{"click":function () {return _vm.close('quit')}}},[_vm._v("Close")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }